import React from 'react'

import { Icon } from 'ui/styled'

import {
  CardIcon,
  CardLabel,
  CardRoot,
  CardValue,
} from './styled'

export default function CourseDetailsStatCard({ icon, label, value }) {
  const variant = icon === 'complete-stat' ? 'success' : 'default'

  return (
    <CardRoot>
      <CardIcon $variant={variant}>
        <Icon icon={icon} />
      </CardIcon>
      <CardValue>{value}</CardValue>
      <CardLabel>{label}</CardLabel>
    </CardRoot>
  )
}
